var api = require('api')
var config = require('common/config')

module.exports = {
  token: function (next, err) {
    api.$http.get(api.$host + '/payment/token').then(function (resp) {
      next(resp.data)
    }, err)
  },
  submit: function (data, next, err) {
    api.$http.post(api.$host + '/payment/create', data).then(next, err)
  },
  confirmPayment: function (data, next, err) {
    api.$http.post(api.$host + '/payment/confirmPayment', data).then(next, err)
  },
  activateTrial: function (data, next, err) {
    api.$http.post(api.$host + '/payment/activateTrial', data).then(next, err)
  },
  update: function (data, next, err) {
    api.$http.put(api.$host + '/subscription', data).then(next, err)
  },
  getCoinPaymentsInfo: function () {
    return api.$http.get(api.$host + '/coinpayments/info')
  },
  getCoinPaymentsCheckout: function (data, next, err) {
    data.successCallback = config.clientHost + '/payment/success'
    data.errorCallback = config.clientHost + '/payment/error'
    api.$http.post(api.$host + '/coinpayments/create', data).then(next, err)
  },
  getPricing: function (code, next, err) {
    api.Service.get({
      code: code
    }).then(function (resp) {
      next(resp.data.pricings)
    }, err)
  },
  isTrial: function (code, next, err) {
    api.Service.check({
      code: code
    }).then(function (resp) {
      next(resp.data.isTrial)
    }, err)
  },
  getBillingPeriods: function (service, next, err) {
    api.BillingPeriod.get({service: service}).then(function (resp) {
      next(resp.data)
    }, err)
  },
  getPaymentContext: function (token, next, err) {
    api.UrlAction.get({
      token: token
    }).then(function (resp) {
      next(resp.data)
    }, err)
  },
  getSubscription: function (next, err) {
    api.Subscription.get().then(next, err)
  },
  cancelSubscription: function (next, err, userIdArray) {
    if (userIdArray) {
      api.Subscription.remove({}, {userIdArray: userIdArray}).then(next, err)
    } else {
      api.Subscription.remove().then(next, err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/Payment.js